import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UiScrollModule } from "ngx-ui-scroll";
import { GadgetComponent } from "./gadget.component";
import { GadgetUserListModule } from "../gadget-user-list/gadget-user-list.module";
import { GadgetSettingsModule } from "../gadget-settings/gadget-settings.component.module";
import { LazyImageModule } from "../lazy-image/lazy-image.module.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MaterialModule,
        SharedModule,
        UiScrollModule,
        GadgetUserListModule,
        GadgetSettingsModule,
        LazyImageModule
    ],
    declarations: [GadgetComponent],
    exports: [GadgetComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
    
})
export class GadgetModule {}